import {
  GREEN_200,
  GREEN_50,
  PRIMARY_900,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
} from './GlobalColors';

const PrimaryTheme = {
  token: {
    colorPrimary: PRIMARY_COLOR,
    colorSecondary: SECONDARY_COLOR,
    fontFamily: 'Nunito',
  },
  components: {
    Table: {
      colorBgContainer: GREEN_50,
      colorFillAlter: GREEN_200,
      colorBorderSecondary: PRIMARY_900,
      borderRadiusLG: 0,
    },
    Modal:{
      colorBgContainer: GREEN_50,
      colorFillAlter: GREEN_200,
      colorBorderSecondary: PRIMARY_900,
    },
    Card:{
      colorFillAlter: GREEN_200,
    },
  },
};

export default PrimaryTheme;
